import { ClipboardListIcon } from "../../icons.js";
import { relativeTime } from "../../../lib/time.js";
import type { WidgetProps } from "../types.js";

const SKIP_TYPES = new Set(["report", "document"]);

function eventLabel(type: string): string {
  return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function RecentActivityWidget({ events, onNavigate }: WidgetProps) {
  const recent = events.filter((e) => !SKIP_TYPES.has(e.eventType)).slice(0, 6);

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 sm:col-span-2">
      <div className="mb-2 flex items-center gap-2">
        <ClipboardListIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Recent activity</h2>
        <button onClick={() => onNavigate("logs")} className="ml-auto text-xs text-(--accent) hover:underline">
          View all logs
        </button>
      </div>
      {recent.length === 0 ? (
        <p className="text-sm text-gray-400 dark:text-gray-500">No events logged yet</p>
      ) : (
        <ul className="divide-y divide-gray-100 dark:divide-gray-800">
          {recent.map((e) => (
            <li key={e.eventId} className="flex items-center justify-between py-1.5 text-sm">
              <span className="text-gray-700 dark:text-gray-300">{eventLabel(e.eventType)}</span>
              <span className="ml-4 shrink-0 text-xs text-gray-400 dark:text-gray-500">{relativeTime(e.occurredAt)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
